import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
	SfcShellAppBar,
	SfcShellAppBarSearch,
	SfcShellLeftNav
} from '@waypoint/react-components';
import WMLogo from './WMLogo';
import HelpLinksModal from './HelpLinksModal';
import NotificationsBtn from './NotificationsBtn';
import SwitchModal from './SwitchModal';
import SupportBannerNew from './SupportBannerNew';
import wmFetch from '../../../funcs/wmFetch';
import $ from 'jquery';
import WMUploader from './WMUploader'
import utils from '../../utilities';

const ShellNavigation = ({
	 showSupportBanner,
	 newConfig,
 }) => {
	const [localSwitchModal, setLocalSwitchModal] = useState(false);
	const [menuProvider, setMenuProvider] = useState(null);

	useEffect(() => {
		// Set top hat height
		const height = showSupportBanner ? '20px' : '0px';
		document.documentElement.style.setProperty('--top-hat-height', height);

		// Force layout alignment
		$('#outer-container').css('margin-left', '0px');
		$('.site-footer').css('margin-left', '0px');

		// To set Active item in the left nav
		const menuProviderToSet = newConfig.navMenuItems;
		setMenuProvider(menuProviderToSet);

		const menuProviderChildren = menuProviderToSet.flatMap(section => section.children);
		const currentLocation = window.location.pathname.replace(/\/+$/, '');
		const activeItem = menuProviderChildren.find(
			item => item.hash && item.hash.replace(/\/+$/, '') === currentLocation
		);

		customElements.whenDefined('sfc-shell-left-nav').then(() => {
			const navNode = document.querySelector('sfc-shell-left-nav');
			if (!navNode) return;

			if (typeof navNode.syncNavigation !== 'function') {
				return;
			}

			if (activeItem) {
				navNode.syncNavigation(activeItem);
			}
		});

	}, [showSupportBanner, newConfig]);


	if (utils.appBarRemoved()) {
		return (
			<div>
				<WMUploader
					status={newConfig.uploadStatus}
					message={newConfig.uploadMessage}
				/>
			</div>
		);
	}

	const largeUser = newConfig.currentUser;

	const personaLabelMap = {
		BUYER: 'Client',
		SELLER: 'Contractor',
		DISPATCHER: 'Team Agent',
	};

	const getPersonaMode = (user) => {
		if (!user) return null;
		if (user.buyer) return 'BUYER';
		if (user.seller) return 'SELLER';
		if (user.dispatcher) return 'DISPATCHER';
		return null;
	};

	const { isBuyerOrgPayNavigation, isSellerOrgPayNavigation } = newConfig.currentUser;

	const featureModePay = isBuyerOrgPayNavigation || isSellerOrgPayNavigation;
	const shouldShowSearchAndNotifications = !featureModePay;
	const shouldShowSwitch = !featureModePay; // Change to allowed feature modes check when ready

	const onUserMenuClick = (event) => {
		const { id } = event.detail.action;
		if (id === 'PROFILE') window.location.href = '/profile?ref=nav';
		if (id === 'SETTINGS') window.location.href = '/account';
		if (id === 'SWITCH') setLocalSwitchModal(true);
	};

	const onEndSupportSessionClick = () => {
		wmFetch('/v3/authSession/authSwitch/end-support-session')
			.then((payload) => {
				const [{ companyId }] = payload;
				window.location.href = `/admin/manage/company/customer_support/${companyId}`;
			})
			.catch((error) => {
				console.error('Error ending support session', error);
			});
	};

	const handleSearch = (event) => {
		const inputValue = event.detail;
		if (!inputValue) return;
		const navFeatureToggle = newConfig.hasNavBarSearchSpaFeature;
		if (navFeatureToggle) {
			window.location = `/manage?dashboardTable=%7B"keyword"%3A%5B"${inputValue}"%5D%7D`;
		} else {
			window.location = `/assignments/search?keyword=${inputValue}`;
		}
	};

	const currentUser = {
		name: largeUser.fullName,
		title: largeUser.email,
		initials: largeUser.fullName.split(' ').map(n => n[0]).join(''),
		avatarUrl: largeUser.smallAvatarUri,
		actions: [
			{ icon: 'user', label: 'Profile', id: 'PROFILE' },
			{ icon: 'action-view-settings', label: 'Settings', id: 'SETTINGS' },
			...(shouldShowSwitch ? [{ separator: true }, { icon: 'action-swap', label: personaLabelMap[getPersonaMode(largeUser)], id: 'SWITCH' }] : []),
		],
	};

	return (
		<React.Fragment>
			{showSupportBanner && (
				<SupportBannerNew onEndSession={onEndSupportSessionClick} />
			)}

			<SfcShellAppBar
				slot="app-bar"
				size="small"
				hasProductLogo
				loggedInUser={currentUser}
				signoutLabel={showSupportBanner ? 'End session' : 'Sign out'}
				onSfcSignout={() => {
					showSupportBanner
						? onEndSupportSessionClick()
						: (window.location.href = '/logout?ref=nav');
				}}
				onSfcAvatarMenuItemSelected={onUserMenuClick}
			>
				{shouldShowSearchAndNotifications && (
					<SfcShellAppBarSearch slot="search" onSfcSearch={handleSearch} appBarSearchLabel="Search my assignments" />
				)}
				<HelpLinksModal
					useZoomChat={newConfig.useZoomChat}
					useZendesk={newConfig.useZendesk}
				/>

				{shouldShowSearchAndNotifications && <NotificationsBtn />}

				<WMLogo logo={newConfig.adpWMlogoURI} href={newConfig.navMenuItems[0].href}/>
			</SfcShellAppBar>

			<SwitchModal
				isOpen={localSwitchModal}
				onClose={() => setLocalSwitchModal(false)}
				personaMode={getPersonaMode(largeUser)}
			/>

			<SfcShellLeftNav slot="nav" menuProvider={menuProvider} />

			<WMUploader
				status={newConfig.uploadStatus}
				message={newConfig.uploadMessage}
			/>
		</React.Fragment>
	);
};

ShellNavigation.defaultProps = {
	showSwitchModal: false,
};

ShellNavigation.propTypes = {
	showSupportBanner: PropTypes.bool.isRequired,
	newConfig: PropTypes.object.isRequired,
};

export default ShellNavigation;


// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/WaypointShellNav/ShellNavigation.js